import ReactMarkdown from 'react-markdown';

import { Column } from '@simplywallst/ui-core';

import { OneColumnExpanded } from '../../styled';
import {
  JourneyContainer,
  JourneyContainerRow,
  StyledReactMarkdown,
  JourneyContentRow,
} from './styled';

export interface Props {
  markdownContent: string[];
}

export const Journey = ({ markdownContent }: Props) => {
  return (
    <JourneyContainer>
      <JourneyContainerRow>
        <OneColumnExpanded>
          <JourneyContentRow>
            {markdownContent.map((item, i) => {
              return (
                <Column key={i} col={6} colSm={3}>
                  <StyledReactMarkdown>
                    <ReactMarkdown source={item} />
                  </StyledReactMarkdown>
                </Column>
              );
            })}
          </JourneyContentRow>
        </OneColumnExpanded>
      </JourneyContainerRow>
    </JourneyContainer>
  );
};
